import { render, staticRenderFns } from "./ltvReport.vue?vue&type=template&id=2d6c9a05&scoped=true&"
import script from "./ltvReport.vue?vue&type=script&lang=js&"
export * from "./ltvReport.vue?vue&type=script&lang=js&"
import style0 from "./ltvReport.vue?vue&type=style&index=0&id=2d6c9a05&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6c9a05",
  null
  
)

export default component.exports